var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"op_animation",class:!_vm.isShowTeeth ? 'gray_bc' : ''},[(_vm.isShowTeeth)?_c('iframe',{attrs:{"width":"100%","height":"100%","src":_vm.toothView,"frameborder":"0","id":"iFrame"}}):_c('div',{staticClass:"no_data"})])}
var staticRenderFns = []

export { render, staticRenderFns }